import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3105';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('kinde_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Certificate API calls
export const certificateAPI = {
  // Get all certificates for user
  getAll: async () => {
    const response = await api.get('/api/certificates');
    return response.data.certificates || [];
  },

  // Get single certificate
  getById: async (id) => {
    const response = await api.get(`/api/certificates/${id}`);
    return response.data;
  },

  // Create new certificate
  create: async (formData) => {
    const response = await api.post('/api/certificates', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Update certificate
  update: async (id, formData) => {
    const response = await api.put(`/api/certificates/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Delete certificate
  delete: async (id) => {
    const response = await api.delete(`/api/certificates/${id}`);
    return response.data;
  },

  // Get download URL for certificate file
  getDownloadUrl: async (id) => {
    const response = await api.get(`/api/certificates/${id}/download`);
    return response.data;
  },

  // Email certificates
  emailCertificates: async (certificateIds, recipientEmail, message) => {
    const response = await api.post('/api/certificates/email', {
      certificateIds,
      recipientEmail,
      message,
    });
    return response.data;
  },
};

// User API calls
export const userAPI = {
  // Get user statistics
  getStats: async () => {
    const response = await api.get('/api/users/stats');
    return response.data;
  },

  // Update notification preferences
  updateNotificationPreferences: async (preferences) => {
    const response = await api.put('/api/users/notification-preferences', preferences);
    return response.data;
  },
};

// Auth API calls
export const authAPI = {
  // Verify Kinde token and create/get user
  verify: async (userData) => {
    const response = await api.post('/api/auth/verify', userData);
    return response.data;
  },

  // Get current user info
  getMe: async () => {
    const response = await api.get('/api/auth/me');
    return response.data;
  },

  // Update user profile
  updateProfile: async (profileData) => {
    const response = await api.put('/api/auth/profile', profileData);
    return response.data;
  },
};

export default api;
